/**
 * OurCove logo components — inline SVG so brand tokens and CSS control color.
 * Three flavors: Mark (icon only), LogoHorizontal, LogoStacked.
 */

export function Mark({ size = 40 }: { size?: number }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      role="img"
      aria-label="OurCove"
      className="ourcove-mark"
    >
      <defs>
        <linearGradient id={`cove-clay-${size}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#E29277" />
          <stop offset="55%" stopColor="#C86B4A" />
          <stop offset="100%" stopColor="#A85236" />
        </linearGradient>
        <linearGradient id={`cove-water-${size}`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#6B8A99" />
          <stop offset="100%" stopColor="#4A6B7A" />
        </linearGradient>
      </defs>
      <path
        d="M 152 70 A 60 60 0 1 0 152 130"
        fill="none"
        stroke={`url(#cove-clay-${size})`}
        strokeWidth={28}
        strokeLinecap="round"
      />
      <circle cx={92} cy={100} r={13} fill={`url(#cove-water-${size})`} />
    </svg>
  );
}

export function Wordmark({ size = 22 }: { size?: number }) {
  return (
    <span className="ourcove-wordmark" style={{ fontSize: size }}>
      Our<strong>Cove</strong>
    </span>
  );
}

export function LogoHorizontal({ markSize = 32 }: { markSize?: number }) {
  return (
    <span className="ourcove-lockup horizontal">
      <Mark size={markSize} />
      <Wordmark size={markSize * 0.7} />
    </span>
  );
}

export function LogoStacked({ markSize = 64 }: { markSize?: number }) {
  return (
    <span className="ourcove-lockup stacked">
      <Mark size={markSize} />
      <Wordmark size={markSize * 0.42} />
    </span>
  );
}
